module.exports = __webpack_public_path__ + "img/logo_lexus_fr.2e76ea46.png";